import { TableHoverActions, useModal, withModalConditionalRender } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Invoice } from '@features/invoicesLegacy/types/invoice'

import { useSegment } from '../../../../../../hooks'
import { InvoiceReconciliationModal as InvoiceReconciliationModalComponent } from '../../../../elements/InvoiceReconclliationModal/InvoiceReconciliationModal'
import { InvoicesTableStaticActionType } from '../../enums/InvoicesTableStaticActionType'

interface InvoicesTableStaticActionsProps {
  invoice: Invoice
}

const InvoiceReconciliationModal = withModalConditionalRender(InvoiceReconciliationModalComponent)

const getInvoiceReconciliationModalId = (id: string) => `${id}-invoice-reconciliation-hover-action`

export const InvoicesTableHoverActions = ({ invoice }: InvoicesTableStaticActionsProps): ReactElement => {
  const { track } = useSegment()
  const { t } = useTranslation()
  const invoiceReconciliationModalId = getInvoiceReconciliationModalId(invoice.id)
  const { open: openInvoiceReconciliationModal } = useModal(invoiceReconciliationModalId)

  const handleRegisterPaymentActionClick = useCallback(() => {
    track('xxx - bookkeeping - QuickAction Clicked', {
      list: 'Invoices',
      button: InvoicesTableStaticActionType.RegisterPayment,
    })
    openInvoiceReconciliationModal()
  }, [track, openInvoiceReconciliationModal])

  return (
    <>
      <TableHoverActions>
        <TableHoverActions.Item
          icon="handCoins"
          label={t('invoices.table.static_actions.register_payment')}
          onClick={handleRegisterPaymentActionClick}
        />
      </TableHoverActions>
      <InvoiceReconciliationModal id={invoiceReconciliationModalId} subject={invoice} />
    </>
  )
}
